export const isLanDevAutoLoginLocation = ({ nodeEnv, hostname, port }) =>
    nodeEnv === 'development' &&
    hostname === '192.168.1.87' &&
    port === '3010';
